import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// SSE streaming over fetch (sends httpOnly cookies via credentials: include)
export async function streamMessage(sessionId, content, { onUser, onDelta, onDone, onError }) {
  const res = await fetch(`${API}/sessions/${sessionId}/stream`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content }),
  });
  if (!res.ok || !res.body) {
    let detail = "Message failed";
    try {
      detail = formatApiErrorDetail((await res.json()).detail);
    } catch {}
    onError && onError({ status: res.status, detail });
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      let evt;
      try {
        evt = JSON.parse(line.slice(5).trim());
      } catch {
        continue;
      }
      if (evt.type === "user") onUser && onUser(evt.message);
      else if (evt.type === "delta") onDelta && onDelta(evt.content);
      else if (evt.type === "done") onDone && onDone(evt.message);
      else if (evt.type === "error") onError && onError({ status: 502, detail: evt.detail });
    }
  }
}
